var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.mobileView)?_c('topcontent'):_vm._e(),(_vm.mobileView)?_c('MobileTopbar'):_vm._e(),(!_vm.mobileView)?_c('Topbar'):_vm._e(),(!_vm.mobileView)?_c('Socialmedia'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }